import { jsx as _jsx } from "react/jsx-runtime";
import { PREFETCH_TYPES } from "constants/prefetch-constants";
import { usePrefetchedLiveBoardAssets } from "client/services/live-board/prefetch-liveboard-service";
const LiveBoardPrefetchedAssetsLinksComponent = ()=>{
    const allPrefetchedLiveBoardAssets = usePrefetchedLiveBoardAssets();
    const dnsPrefetchedDomains = allPrefetchedLiveBoardAssets.filter((asset)=>asset.type === PREFETCH_TYPES.DNS_PREFETCH);
    const preConnectedDomains = allPrefetchedLiveBoardAssets.filter((asset)=>asset.type === PREFETCH_TYPES.PRECONNECT);
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map((prefetchedDomain, index)=>/*#__PURE__*/ _jsx("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index)),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map((preConnectedDomain, index)=>/*#__PURE__*/ _jsx("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            }, index))
    ];
};
export default LiveBoardPrefetchedAssetsLinksComponent;
